import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/useAuthStore';

/**
 * platform_role ∈ (staff, superadmin) 또는 orgs[] 중 org_admin 있어야 통과.
 * 그 외 → /no-access (portal 안내).
 */
export function RequireAdminRole({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;

  const isPlatform = user.platform_role === 'staff' || user.platform_role === 'superadmin';
  const isOrgAdmin = user.orgs.some((o) => o.role === 'org_admin');

  if (!isPlatform && !isOrgAdmin) {
    return <Navigate to="/no-access" replace />;
  }
  return <>{children}</>;
}

export function RequirePlatformRole({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  if (user.platform_role !== 'staff' && user.platform_role !== 'superadmin') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
